import gql from "graphql-tag";

export default gql`
  mutation DeleteDocumentType($id: Float!) {
    deleteDocumentType(id: $id)
  }
`;
